import { Controller } from "@hotwired/stimulus"

// Shows/hides the mobile navigation overlay.
export default class extends Controller {
  static targets = ["overlay", "panel"]

  connect() {
    this._onResize = () => {
      if (window.matchMedia("(min-width: 1024px)").matches) this.setOpen(false)
    }
    window.addEventListener("resize", this._onResize)
  }

  disconnect() {
    window.removeEventListener("resize", this._onResize)
    this.setOpen(false)
  }

  toggle() {
    const open = !this.overlayTarget.classList.contains("hidden")
    this.setOpen(!open)
  }

  close() {
    this.setOpen(false)
  }

  setOpen(open) {
    if (open) {
      this.overlayTarget.classList.remove("hidden")
      document.body.style.overflow = "hidden"
    } else {
      this.overlayTarget.classList.add("hidden")
      document.body.style.overflow = ""
    }
  }
}
